import {
  CheckMetadata,
  ComparisonCheckType,
  createAttributeComparisonTableCheckMetadatas,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import { IdExtractionInconsistencyDetection } from 'dashboard/models/check';

export const computeIdExtractionInconsistencyDetectionMetadata = (
  check: IdExtractionInconsistencyDetection,
): CheckMetadata => {
  const metadata = check.metadata;
  const attributeComparisons = metadata?.['attribute-comparisons'];

  if (attributeComparisons) {
    return {
      metadata: createAttributeComparisonTableCheckMetadatas(
        attributeComparisons,
        ComparisonCheckType.IdExtractionInconsistencyDetection,
      ),
      hideIfVerificationPassed: false,
    };
  }

  return {
    metadata: [],
    hideIfVerificationPassed: false,
  };
};
